enum EnvironmentEnum {
  QA = "qa",
  STAGING = "staging",
  PRODUCTION = "prod"
}

export default EnvironmentEnum;
